module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/pdfs/3a2b9177326df4bae628d32ed68aa8c2.pdf";